import axios from 'axios'

const axiosInstance = axios.create({
  headers: { 'Content-Type': 'application/json; charset=utf-8', Accept: 'text/json' }
})

export const sourceAxios = axios.CancelToken.source()

export const webApiService = {

  createLoginCode: async () => {
    const url = `${import.meta.env.VITE_CRUD_PHONECHECK}createLoginCode`
    return await axiosInstance.request({ method: 'POST', url }).then((res: any) => res.data)
  },
  save: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}save`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllSbu: async (slug: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllSbu/${slug}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllBrandBySbu: async (idSbu: string, slug: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllBrandBySbu/${idSbu}/${slug}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllModelByBrand: async (idSbu: string, idBrand: string, slug: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllModelByBrand/${idSbu}/${idBrand}/${slug}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllCapacityByModel: async (data: { idSbu: string, idBrand: string, idModel: string, seller: string }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllCapacityByModel`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllCPU: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllCPU`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllGenerationByCPU: async (idCPU: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllGenerationByCPU/${idCPU}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllScreenByCPU: async (idCPU: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllScreenByCPU/${idCPU}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllRamByCPU: async (idCPU: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllRamByCPU/${idCPU}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllCapacity: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllCapacity`
    return await axiosInstance.request({ method: 'POST', data, url }).then((res: any) => res.data)
  },
  getAllQuestions: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllQuestions`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getConfigBySlug: async (slug: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getConfigBySlug/${slug}`
    console.log('🚀 ~ getConfigBySlug ~ url:', url)
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getUserProfile: async (_email: string, _poolId: string) => {
    const url = `${import.meta.env.VITE_SERVICE_USER_PROFILE}getByEmailAndPoolId/${_email}/${_poolId}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  // `params` va como query string y hoy solo lo usa WOM ({ sso, id_role }): su sesión
  // viene del SSO sin usuario en la BD, así que el conteo se filtra por rol y no por email.
  getCountStatus: async (email: string, seller: string, params?: { sso: boolean, id_role: number }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getCountStatus/${email}/${seller}`
    return await axiosInstance.request({ method: 'GET', url, params }).then((res: any) => res.data)
  },
  getStatusTrends: async (seller: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getStatusTrends?seller=${seller}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getListTradeIn: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getList`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updateOnlyFolio: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}updateOnlyFolio`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updateOnlySeals: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}updateOnlySeals`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updatePCheck: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}updatePCheck`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  checkSeal: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}checkSeal`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  rechazarTradein: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}rechazarTradein`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllCR: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllCR`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  update: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}update`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  resendCode: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}resendCode`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  recalculate: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}recalculate`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  saveFiles: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveFiles`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getFiles: async (_tradeinId: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getFiles/${_tradeinId}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getHistoryById: async (data: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getHistoryById`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getById: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getById/${data.id_tradein}/${data.email}/${data.id_role}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getChecklistQuestions: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getChecklistQuestions`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getEntrysById: async (_tradeinId: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAnswersById/${_tradeinId}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  sendToCustody: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}sendToCustody`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllBySeal: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllBySeal`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  validitySeal: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}validitySeal`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getDataByModel: async (data: { idSbu: string, idBrand: string, idModel: string, seller: string }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getDataByModel`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllGPU: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllGPU`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getAllAnswers: async (idTradein: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllAnswers/${idTradein}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getTradeinConfig: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getTradeinConfig`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getByEnvelopeId: async (idContract: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getByEnvelopeId/${idContract}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  signContract: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}signContract`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  sendMails: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}sendMails`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  createDevice: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}createDevice`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => console.log('respuesta => ', res))
  },
  saveDeviceRequest: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}saveDeviceRequest`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getDeviceRequests: async (params: { page?: number, pageSize?: number, seller?: string, id_seller?: number, id_sbu?: number | null, search?: string }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getDeviceRequests`
    return await axiosInstance.request({ method: 'GET', url, params }).then((res: any) => res.data)
  },
  saveFromBulk: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveFromBulk`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  saveFromBulkTelcel: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}saveFromBulkTelcel`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getListSbu: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getListSbu/`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  saveFormAnswers: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveFormAnswers/`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  saveDataAccount: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveDataAccount/`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllDataBank: async (slug?: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllDataBank/`
    return await axiosInstance.request({ method: 'GET', url, params: { slug } }).then((res: any) => res.data)
  },
  uploadProof: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}uploadProof/`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  inWarehouse: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}inWarehouse`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllStoreBySeller: async (seller: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllStoreBySeller/${seller}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getStoreRegions: async (seller?: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getStoreRegions`
    return await axiosInstance.request({ method: 'GET', url, params: { seller } }).then((res: any) => res.data)
  },
  getStoresByRegion: async (seller?: string, region?: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getStoresByRegion`
    return await axiosInstance.request({ method: 'GET', url, params: { seller, region } }).then((res: any) => res.data)
  },
  getRegionByUser: async (id: number) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getRegionByUser`
    return await axiosInstance.request({ method: 'GET', url, params: { id } }).then((res: any) => res.data)
  },
  getSkuByModel: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getSkuByModel`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  sendGiftcard: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}sendGiftcard`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getListForTechnicians: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getListForTechnicians`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  // Traduce el nombre de sucursal que manda el SSO de WOM (la aserción SAML trae
  // nombres, no ids) al id_store de la BD.
  getStoreByName: async (name: string, seller?: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getStoreByName`
    return await axiosInstance.request({ method: 'GET', url, params: { name, seller } }).then((res: any) => res.data)
  },
  getStoreByUser: async (idUser: number) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getStoreByUser/${idUser}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  saveIAResult: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveIAResult`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getIAEvaluation: async (idTradein: number) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getIAEvaluation/${idTradein}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  getListMulti: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getListMulti`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  receiptDevices: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}receiptDevices`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  checkLoginCode: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}checkLoginCode`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updateDocument: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}updateDocument`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updatePurchaseTradein: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}updatePurchaseTradein`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getAllContributions: async (seller: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllContributions/${seller}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  saveContribution: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}saveContribution`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getContribution: async (id: number, seller: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getContribution/${id}/${seller}`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  activeContribution: async (data: { seller: string, idSbu: number, idBrand: number, idModel: number }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}activeContribution`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updateContract: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}updateContract`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },

  checkTestMX: async (serie: string, idTradein: string) => {
    const url = `${import.meta.env.VITE_WEBHOOK_NOVABENCH}checkTestMX/${serie}/${idTradein}`
    return await axiosInstance.request({
      method: 'GET',
      url,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res: any) => res.data)
  },

  getAllDevicesPurchased: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllDevicePurchased`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },

  checkTestCL: async (serie: string, idTradein: string) => {
    const url = `${import.meta.env.VITE_WEBHOOK_NOVABENCH}checkTest/${serie}/${idTradein}`
    return await axiosInstance.request({
      method: 'GET',
      url,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res: any) => res.data)
  },
  getAllBuy: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}getAllBuy`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  updateBatteryStatus: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN}updateOnlyBattery`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getHuaweiDeviceList: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}getHuaweiDeviceList`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  /* Listado de modelos que WOM vende, para elegir el que compró el cliente al recibir el equipo. */
  getWomDeviceList: async (seller: string) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getWomDeviceList`
    return await axiosInstance.request({ method: 'GET', url, params: { seller } }).then((res: any) => res.data)
  },
  updateBankInfo: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}updateBankInfo`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  forwardGiftcardEmail: async (data: any) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED}forwardGiftcardEmail`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  /* haveBatteryStatus: 0 = no había cómo revisar el estado (isBatteryHealthy viaja en null), 1 = sí se pudo revisar */
  updateBatteryHealth: async (data: { idTradein: number, isBatteryHealthy: number | null }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}updateBatteryHealth`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  /* Guarda la foto de la etiqueta y devuelve la serie que leyó Gemini. */
  readSerieFromImage: async (data: {
    id_tradein: number,
    seller?: string,
    store_user: string,
    sbu: string,
    brand: string,
    model: string,
    file: { name: string, base64: string }
  }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}readSerieFromImage`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getModelBatteryList: async () => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}getModelBatteryList`
    return await axiosInstance.request({ method: 'GET', url }).then((res: any) => res.data)
  },
  /* actualiza el grade quality a partir del grado IA; batterySuffix por ahora siempre '1' */
  updateGradeQuality: async (data: { idTradein: number, batterySuffix: string }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}updateGradeQuality`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  updateOnlyBatteryHealth: async (data: { idTradein: number, isBatteryHealthy: number | null }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}updateOnlyBatteryHealth`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  /* Guarda la foto del ticket de venta que toma el vendedor en tienda. */
  uploadTicket: async (data: {
    id_tradein: number,
    seller?: string,
    store_user: string,
    file: { name: string, base64: string }
  }) => {
    const url = `${import.meta.env.VITE_CRUD_TRADEIN_EXTENDED_2}uploadTicket`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  }
}
